module.exports = __webpack_public_path__ + "img/kuang_up_left_chang.0b395526.png";